import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiErrorMessage } from '../utils/errors';
import Icon from './Icon';

const ForgotPassword: React.FC = () => {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  // Set once the request succeeds and left true even after -- re-submitting
  // shouldn't ever contradict the generic message already shown.
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err, 'Something went wrong. Please try again.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1 className="login-logo">
          <Icon name="pan" className="icon" /> RecipeEngine
        </h1>
        <p className="login-tagline">Reset your password</p>

        {error && <div className="login-error">{error}</div>}

        {sent ? (
          <p>If an account with that email exists, we've sent a password reset link. Check your inbox.</p>
        ) : (
          <>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary" disabled={submitting} style={{ width: '100%' }}>
                {submitting ? 'Sending...' : 'Send reset link'}
              </button>
            </div>
          </>
        )}

        <p className="login-tagline" style={{ margin: 0 }}>
          <Link to="/">Back to sign in</Link>
        </p>
      </form>
    </div>
  );
};

export default ForgotPassword;
